import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
import Vue from "vue";

export const departmentProcessDatasourceDatasubject = createCrudVuexModule({
  namespaced: true,
  path: "/quick-hierarchy/process-datasource-data",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/quick-hierarchy/process-datasource-data`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/quick-hierarchy/process-datasource-data`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/quick-hierarchy/process-datasource-data/${item._id}`);
          const departmentName = item.department ? Vue.filter("translate")(item.department.name) : "";
          const processName = item.process ? Vue.filter("translate")(item.process.name) : "";
          const datasourceName = item.datasource ? Vue.filter("translate")(item.datasource.name) : "";

          success.push(`${processName} - ${datasourceName} - ${departmentName}`);
        } catch (error) {
          const departmentName = item.department ? Vue.filter("translate")(item.department.name) : "";
          const processName = item.process ? Vue.filter("translate")(item.process.name) : "";
          const datasourceName = item.datasource ? Vue.filter("translate")(item.datasource.name) : "";
          failed.push({
            name: `${processName} - ${datasourceName} - ${departmentName}`,
            error: error.data.message,
          });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});

export const workspaceDepartmentProcessDatasourceDatasubject = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/quick-hierarchy/process-datasource-data",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async save({ dispatch, getters }, payload) {
      payload = await dispatch("preparePayload", {
        editedEntity: getters.editedEntity,
        form: payload,
      });

      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.post(`/workspace/quick-hierarchy/process-datasource-data`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.put(`/workspace/quick-hierarchy/process-datasource-data`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/workspace/quick-hierarchy/process-datasource-data/${item._id}`);
          const departmentName = item.department ? Vue.filter("translate")(item.department.name) : "";
          const processName = item.process ? Vue.filter("translate")(item.process.name) : "";
          const datasourceName = item.datasource ? Vue.filter("translate")(item.datasource.name) : "";

          success.push(`${processName} - ${datasourceName} - ${departmentName}`);
        } catch (error) {
          const departmentName = item.department ? Vue.filter("translate")(item.department.name) : "";
          const processName = item.process ? Vue.filter("translate")(item.process.name) : "";
          const datasourceName = item.datasource ? Vue.filter("translate")(item.datasource.name) : "";
          failed.push({
            name: `${processName} - ${datasourceName} - ${departmentName}`,
            error: error.data.message,
          });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});
